import React, { Component, ReactElement } from "react";
import classnames from "classnames";

import { Icon, IconName } from "@formant/ui/component/common/Icon";

import * as styles from "./RowTitle.scss";

export interface IRowTitleProps {
    title: string;
    icon: IconName | ReactElement | null;
    className?: string;
    children?: React.ReactNode;
}

export class RowTitle extends Component<IRowTitleProps> {
    public render() {
        const { icon, title, className, children } = this.props;
        return (
            <div className={classnames(styles["row-title"], className)}>
                <div className={styles.icon}>
                    {typeof icon === "string" ? <Icon name={icon} /> : icon}
                </div>
                {children}
                <span>{title}</span>
            </div>
        );
    }
}
